export const SET_TITLE = 'SET_TITLE';
export const SET_DASHBOARD = 'SET_DASHBOARD';
export const SET_CACHE_FILTER = 'SET_CACHE_FILTER';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_DEFAULT_CURRENCY = 'SET_DEFAULT_CURRENCY';
export const SET_TEMP_CURRENCY = 'SET_TEMP_CURRENCY';
// export const ADD_DASHBOARD = 'ADD_DASHBOARD';
// export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
// export const DELETE_DASHBOARD = 'DELETE_DASHBOARD';

const setTitle = (title, key) => {
  return {
    type: SET_TITLE,
    payload: {
      title,
      key
    }
  };
};

const setDashboards = (dashboards) => {
  return {
    type: SET_DASHBOARD,
    payload: dashboards
  };
};

const setNotification = (msg) => {
  return {
    type: SET_MESSAGE,
    payload: msg
  };
};

const setCacheFilter = (dashboardKey, graphId, filter) => {
  return {
    type: SET_CACHE_FILTER,
    payload: {
      dashboardKey,
      graphId,
      filter
    }
  };
};

const setDashboardCurrency = (currency) => {
  return {
    type: SET_CURRENCY,
    payload: currency
  };
};

const setDefaultCurrency = (currencyVal) => {
  return {
    type: SET_DEFAULT_CURRENCY,
    payload: currencyVal
  };
};

const setTempCurrency = (currencyVal) => {
  return {
    type: SET_TEMP_CURRENCY,
    payload: currencyVal
  };
};

// const addDashboard = (dashboard) => {
//   return {
//     type: ADD_DASHBOARD,
//     payload: dashboard
//   };
// };
// const updateDashboard = (id, dashboard) => {
//   return {
//     type: UPDATE_DASHBOARD,
//     payload: { id, dashboard }
//   };
// };
// const deleteDashboard = (id) => {
//   return {
//     type: DELETE_DASHBOARD,
//     payload: id
//   };
// };

const siteAction = {
  setTitle,
  setDashboards,
  setNotification,
  setCacheFilter,
  setDashboardCurrency,
  setDefaultCurrency,
  setTempCurrency
  // addDashboard,
  // updateDashboard,
  // deleteDashboard
};

export default siteAction;
